export default function genererModeReglement() {
  return {
    libelle: '',
  };
}



// WEBPACK FOOTER //
// ./src/services/devis/genererModeReglement.js